import { render, staticRenderFns } from "./changeLPwd.vue?vue&type=template&id=20acab99"
import script from "./changeLPwd.vue?vue&type=script&lang=js"
export * from "./changeLPwd.vue?vue&type=script&lang=js"
import style0 from "./changeLPwd.vue?vue&type=style&index=0&id=20acab99&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports